const CV_PART_TYPE = {
  Page: 'page',
}

const CV_PART_ACTIVITY_CONFIG = {
  [CV_PART_TYPE.Page]: true,
}

export { CV_PART_TYPE, CV_PART_ACTIVITY_CONFIG };
